import request from '@/Utilities/httpRequest';

function initialState() {
    return {
        data: {},
        imagesUrl: null,
        sku: null,
        groupId: null
    };
}

export default {
    strict: true,
    namespaced: true,
    state: initialState,
    mutations: {
        setData(state, payload) {
            if(Object.keys(state.data).length > 0) {
                const struct = state.data.struct ?? {};
                const videos = state.data.videos ?? {};
                state.data.struct = {...struct,...payload.struct};
                state.data.videos = {...videos,...payload.videos};
            }else{
                state.data = payload;
            }
        },
        setImagesUrl(state, payload) {
            state.imagesUrl = payload;
        },
        setSKU(state, payload) {
            state.sku = payload;
        },
        setGroupId(state, payload) {
            state.groupId = payload;
        },
        reset(state){
          // acquire initial state
          const s = initialState()
          Object.keys(s).forEach(key => {
            state[key] = s[key]
          });
        }
    },
    actions: {
        setData(context, payload) {
            context.commit('setData', payload);
        },
        setSKU(context, payload) {
            context.commit('setSKU', payload);
        },
        setGroupId(context, payload) {
            context.commit('setGroupId', payload);
        },
        async updateData(context, payload) {
            if(payload) {
                let galleryData = context.getters?.struct??null;
                if(!galleryData && payload.masterId){
                    let url = payload.url ?? context.getters.imagesUrl;
                    const {data} = await request.get(url, {id: payload.masterId});
                    if(data && Object.keys(data).length > 0) {
                        context.commit('setData', data);
                    }
                }
            } 
        },
        reset(context){
            context.commit('reset');
        }
    },
    getters: {
        imagesUrl: state => state.imagesUrl,
        struct: (state, getters, rootState, rootGetters) => {
            let struct  = getters.data?.struct ?? {};
            let videos  = getters.data?.videos ?? {};
            let sku     = getters.sku;
            let groupId = getters.groupId;
            let masterSKU = rootGetters.masterSku;
            let skuVideos = [];
            if(!(struct[sku] ?? null)){
                sku     = (struct[rootGetters.SKU] ?? null) ? rootGetters.SKU : masterSKU;
            }

            //Get videos to SKU, if not exist get from Master, if not exist get from other sku
            skuVideos = videos[sku] || [];
            if(skuVideos.length == 0 && (videos[masterSKU]?? null)){
                if((Object.values(videos[masterSKU])[0]?.groupId ?? '') != groupId){
                    skuVideos = [];
                }
            }

            if(skuVideos.length == 0 && Object.values(videos).length > 0){
                Object.values(videos).every( (v) => {
                    if((Object.values(v)[0]?.groupId ?? '') == groupId){
                        skuVideos = v;
                        return false;
                    }
                    return true;
                });
            }

            if(struct[sku] ?? null) {
                return {
                    'groupId': groupId,
                    'sku': sku,
                    'images': struct[sku].images || [],
                    'thumbs': struct[sku].thumbs || [],
                    'zoomImages': struct[sku].zoom || [],
                    'isAppAndroid': getters.data.isAppAndroid ?? false,
                    'isAppIOS': getters.data.isAppIOS ?? false,
                    'isMod': getters.data.isMod ?? false,
                    'isNutrition': getters.data.isNutrition ?? false,
                    'videos': skuVideos
                };
            }
            return null;
        },
        data: state => state.data,
        sku: (state, getters, rootState, rootGetters) => {
            return state.sku ?? rootGetters.SKU ?? rootGetters.masterSku;
        },
        groupId: (state, getters, rootState, rootGetters) => {
            return state.groupId ?? rootGetters.GroupId;
        }
    }
}